(function ($) {
	$(document).on('click', '[data-youtube]', function () {
		var $el = $(this),
			id = $el.data('video-id'),
			message = `
					<div class="mp-video-box">
						<iframe src="https://www.youtube.com/embed/${id || ''}?modestbranding=1&autoplay=1&showinfo=0&autohide=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
				`
		;

		Drupal.showModal({
			message,
			className: 'mp-modal mp-modal--video'
		})
	});
})(jQuery);
